export default "__VITE_ASSET__3e4317aa__"